import React from "react";
import { useParams } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
} from "reactstrap";
const ListePage = () => {
  const listeBalise = JSON.parse(localStorage.getItem("listeBalise"));

  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink style={navStyle} className={`nav-link active`} to="#details">
            Liste des balises
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  return (
    <React.Fragment>
      <div
        className="page-content"
        style={{ fontFamily: "sans-serif", textAlign: "center" }}
      >
        <div className="container-fluid">
          <div dangerouslySetInnerHTML={{ __html: listeBalise }} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListePage;
